import type { FC } from "react";

import { SVG_MUI } from "@ryde/assets";
import { formatHHmmTime, TimeZoneEnum, useFormats } from "@ryde/shared";

import { AvailabilityDirectionLabel } from "../../../../common/course-availability";
import { type ICourseScheduleCellRowProps } from "./course-schedule-cell.models";
import {
  isPickupDirection,
  resolveScheduleDirectionLabel,
} from "./course-schedule-cell.utils";

export const CourseScheduleCellRow: FC<ICourseScheduleCellRowProps> = ({
  schedule,
  courseDirectionTemplate,
  stationsInfo,
}) => {
  const { timeFormat } = useFormats();
  const pickup = isPickupDirection(schedule.direction);
  const directionLabel = resolveScheduleDirectionLabel(schedule.direction);

  return (
    <div className="course-schedule-cell__row" data-e2e="availability-row">
      {pickup ? (
        <SVG_MUI.DirectionPickupBg3SVG />
      ) : (
        <SVG_MUI.DirectionDropoffBg3SVG />
      )}
      <div
        className="course-schedule-cell__direction"
        data-e2e="schedule-direction"
      >
        <AvailabilityDirectionLabel
          scheduleDirection={schedule.direction}
          courseDirectionTemplate={courseDirectionTemplate}
          stationsInfo={stationsInfo}
          label={directionLabel}
        />
      </div>
      <div className="course-schedule-cell__time">
        {formatHHmmTime(schedule.time, timeFormat, TimeZoneEnum.UTC)}
      </div>
      <div
        className="course-schedule-cell__day-types"
        data-e2e="schedule-day-types"
      >
        {schedule.dayTypeNames?.display}
      </div>
    </div>
  );
};
